import { SERVICES } from 'tenant/config';
import { v1 as uuidv1 } from 'uuid';
import sendEventToSegment from './sendEventToSegment';

class TrackeableEvent {
  constructor() {
    this.eventId = null;
  }
  triggerEvent = async (event, data) => {
    if (!SERVICES.SEGMENT) return null;
    if (!this.eventId) console.warn('Triggering TrackeableEvent without eventId');
    return await sendEventToSegment(event, {
      ...data,
      timestamp: new Date().getTime(),
      eventId: this.eventId,
    });
  };
  start = async (event, data) => {
    this.eventId = uuidv1();
    return await this.triggerEvent(event, data);
  };
  end = async (event, data) => {
    await this.triggerEvent(event, data);
    this.eventId = null;
    return null;
  };
}

export default TrackeableEvent;
